// Small UI helpers used across screens.
import { getIntlLocale } from '../i18n/runtime';

export function parseApiDate(value) {
  if (!value) return new Date(NaN);
  if (value instanceof Date) return value;
  let normalized = String(value);
  if (!/[Zz]|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    normalized = `${normalized}Z`;
  }
  return new Date(normalized);
}

export function formatApiDateTime(value, options) {
  const date = parseApiDate(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(getIntlLocale(), options);
}

export function formatRelative(iso) {
  if (!iso) return "—";
  const d = parseApiDate(iso); const now = Date.now();
  const diffMs = now - d.getTime(); const sec = Math.round(diffMs / 1000);
  if (sec < 60) return `${sec}s`;
  const min = Math.round(sec / 60); if (min < 60) return `${min}m`;
  const hr = Math.round(min / 60); if (hr < 24) return `${hr}h`;
  const day = Math.round(hr / 24); return `${day}d`;
}

export function initials(name) {
  if (!name) return "·";
  return name.split(" ").map(n => n[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}

export function clamp(s, n) {
  if (!s) return "";
  return s.length > n ? s.slice(0, n - 1) + "…" : s;
}
